// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608311946/js/" + chunkId + "." + {"44":"509b5024","225":"c942fdf5","481":"68d1ef82","486":"6933390a","770":"25c74c57"}[chunkId] + ".0.6927041793799043.chunk.js";
};